<template>
  <b-overlay :show="show" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
    <b-card title="Installation Data">
      <!-- Device -->
      <b-row>
        <b-col cols="6">
          <b-form-group label="Device" label-for="v-Device">
            <validation-provider #default="{ errors }" name="Device" rules="required">
              <v-select id="v-Device" v-model="form.select_1" placeholder="Chose Device" autocomplete="off"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="DeviceOptions"
                :reduce="DeviceOptions => DeviceOptions.value" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Status" label-for="v-Status">
            <validation-provider #default="{ errors }" name="Status" rules="required">
              <b-form-input id="v-Status" readonly v-model="form.text_6" placeholder="Status" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-form-input id="pac-input" placeholder="Search" />
      <div id="map"></div>
      <hr>
      <b-row>
        <!-- Latitude -->
        <b-col cols="6">
          <b-form-group label="Latitude" label-for="v-Latitude">
            <validation-provider #default="{ errors }" name="Latitude" rules="required">
              <b-form-input id="v-Latitude" readonly :state="errors.length > 0 ? false : null" v-model="form.text_3"
                placeholder="Latitude" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- Longtitude -->
        <b-col cols="6">
          <b-form-group label="Longtitude" label-for="v-Longtitude">
            <validation-provider #default="{ errors }" name="Longtitude" rules="required">
              <b-form-input id="v-Longtitude" readonly :state="errors.length > 0 ? false : null" v-model="form.text_4"
                placeholder="Longtitude" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="">
      <!-- <b-card-text>Bank.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <b-col cols="12">
              <div class="h-50 d-inline-block"></div>
            </b-col>
            <!-- Instalator Company -->
            <b-col cols="6" style="display: none;">
              <b-form-group label="Instalator Company" label-for="v-Instalator Company">
                <b-form-input id="v-Instalator Company" v-model="form.text_1" placeholder="Instalator Company" />
              </b-form-group>
            </b-col>
            <!-- Instalator Name -->
            <b-col cols="6" style="display: none;">
              <b-form-group label="Instalator Name" label-for="v-Instalator Name">
                <b-form-input id="v-Instalator Name" v-model="form.text_2" placeholder="Instalator Name" />
              </b-form-group>
            </b-col>
            <!-- Province -->
            <b-col cols="6">
              <b-form-group label="Province" label-for="v-Province">
                <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="ProvinceOptions"
                  :reduce="ProvinceOptions => ProvinceOptions.value" id="v-Province" v-model="form.select_6" label="title"
                  :placeholder="province ? province : '--Select Province --'" class="w-100" />
              </b-form-group>
            </b-col>
            <!-- Regency -->
            <b-col cols="6">
              <b-form-group label="Regency" label-for="v-Regency">
                <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="RegencyOptions"
                  :reduce="RegencyOptions => RegencyOptions.value" id="v-Regency" v-model="form.select_7" label="title"
                  :placeholder="regency ? regency : '--Select Province --'" class="w-100" />
              </b-form-group>
            </b-col>
            <!-- District -->
            <b-col cols="6" style="display: none;">
              <b-form-group label="District" label-for="v-District">
                <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="DistrictOptions"
                  :reduce="DistrictOptions => DistrictOptions.value" id="v-District" v-model="form.select_8" label="title"
                  placeholder="--Select District --" class="w-100" />
              </b-form-group>
            </b-col>
            <!-- Site -->
            <b-col cols="6">
              <b-form-group label="Site" label-for="v-Site">
                <validation-provider #default="{ errors }" name="Site" rules="required">
                  <v-select id="v-Site" v-model="form.select_9" placeholder="Chose  Site" autocomplete="off"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="SiteOptions"
                    :reduce="SiteOptions => SiteOptions.value" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--Change/Replace-->
            <b-col cols="6">
              <b-form-group label="Select Type">
                <validation-provider #default="{ errors }" name="Change/Replace" rules="required">
                  <v-select placeholder="Change/Replace" :reduce="(choice) => choice.value"  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" v-model="selectedChoice" :options="choice" label="title" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!--Installation Date-->
            <b-col cols="6" v-if="this.selectedChoice === 'Replace'">
              <b-form-group label="Installation Date">
                <flat-pickr v-model="form.date_1" class="form-control" :config="{ dateFormat: 'd-m-Y' }"
                  placeholder="DD-MM-YYYY" />
              </b-form-group>
            </b-col>
            <!-- Update Interval -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Update Interval">
                <b-input-group>
                  <b-form-input type="number" id="v-Update Interval" v-model="form.text_5"
                    placeholder="Update Interval" />
                  <!-- <b-input-group-append is-text>
                <b>&nbsp;Minute</b>
                </b-input-group-append> -->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" style="display: none;">
              <b-form-group label="Max Limit">
                <b-input-group>
                  <b-form-input type="number" id="v-Max Limit" v-model="form.text_6" placeholder="Max Limit" />
                  <!-- <b-input-group-append is-text>
                <b>&nbsp;Minute</b>
                </b-input-group-append> -->
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" style="display: none;">
              <b-form-group label="Min Limit">
                <b-input-group>
                  <b-form-input type="number" id="v-Min Limit" v-model="form.text_7" placeholder="Min Limit" />
                  <!-- <b-input-group-append is-text>
                <b>&nbsp;Minute</b>
                </b-input-group-append> -->
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- media -->
            <b-col cols="12" style="display: none;">
              <b-form-group label="Installation Documentation File" label-for="v-desc">
                <br>
                <b-media no-body>
                  <iframe :src="form.UrlInstalasi" width="90%" height="700" />

                  <b-media-body class="mt-75 ml-75">
                    <!-- upload button -->
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="sm" class="mb-75 mr-75"
                      @click="$refs.refInputElInstalasi.$el.click()">
                      Upload
                    </b-button>
                    <b-form-file ref="refInputElInstalasi" v-model="form.instalasi" accept="application/pdf"
                      :hidden="true" plain @change="UploadRenderInstalasi" />
                    <!--/ upload button -->

                    <!-- reset -->
                    <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" size="sm"
                      class="mb-75 mr-75">
                      Reset
                    </b-button>
                    <!--/ reset -->
                    <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                  </b-media-body>
                </b-media>
              </b-form-group>
            </b-col>
            <b-col cols="12" style="display: none;">
              <b-form-group label="BAST File" label-for="v-desc">
                <br>
                <b-media no-body>
                  <iframe :src="form.UrlBast" width="90%" height="700" />

                  <b-media-body class="mt-75 ml-75">
                    <!-- upload button -->
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="sm" class="mb-75 mr-75"
                      @click="$refs.refInputElBast.$el.click()">
                      Upload
                    </b-button>
                    <b-form-file ref="refInputElBast" v-model="form.bast" accept="application/pdf" :hidden="true" plain
                      @change="UploadRenderBast" />
                    <!--/ upload button -->

                    <!-- reset -->
                    <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" size="sm"
                      class="mb-75 mr-75">
                      Reset
                    </b-button>
                    <!--/ reset -->
                    <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                  </b-media-body>
                </b-media>
              </b-form-group>
            </b-col>
            <b-col cols="12" style="display: none;">
              <b-form-group label="Device Calibration File" label-for="v-desc">
                <br>
                <b-media no-body>
                  <iframe :src="form.UrlKalibrasi" width="90%" height="700" />

                  <b-media-body class="mt-75 ml-75">
                    <!-- upload button -->
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="sm" class="mb-75 mr-75"
                      @click="$refs.refInputElKalibrasi.$el.click()">
                      Upload
                    </b-button>
                    <b-form-file ref="refInputElKalibrasi" v-model="form.kalibrasi" accept="application/pdf"
                      :hidden="true" plain @change="UploadRenderKalibrasi" />
                    <!--/ upload button -->

                    <!-- reset -->
                    <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" variant="outline-secondary" size="sm"
                      class="mb-75 mr-75">
                      Reset
                    </b-button>
                    <!--/ reset -->
                    <b-card-text>Allowed PDF. Max size of 2000kB</b-card-text>
                  </b-media-body>
                </b-media>
              </b-form-group>
            </b-col>
            <!--/ media -->
            <!-- submit and reset -->
            <b-col cols="12">
              <div class="h-50 d-inline-block"></div>
            </b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1"
                @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" @click="reset"
                variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BInputGroup, BInputGroupAppend, BOverlay, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import { mapState } from 'vuex'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
export default {
  components: { vSelect, flatPickr, BInputGroup, BInputGroupAppend, BOverlay, ValidationProvider, ValidationObserver, BCard, BCardText, BRow, BCol, BFormGroup, BFormCheckbox, BFormInput, BFormFile, BForm, BButton, BMedia, BMediaAside, BMediaBody, BLink, BImg },
  directives: { Ripple },
  data() {
    return {
      form: {
        id: null, 
        select_1: '', 
        text_1: '', 
        text_2: '', 
        text_3: '', 
        text_4: '', 
        text_5: '', 
        text_6: '', 
        date_1: '', 
        select_9: '',
        UrlInstalasi: '', 
        setUpload: 'none', 
        instalasi: null,
        UrlBast: '', 
        setUpload2: 'none', 
        bast: null,
        UrlKalibrasi: '', 
        setUpload3: 'none', 
        kalibrasi: null,
        select_6: '', 
        select_7: '', 
        select_8: '',
      },
      show: false,
      contentData: null,
      geocoder: '',
      selectedChoice: 'Change',
      choice: [
        { title: 'changes', value: 'Change' },
        { title: 'replace', value: 'Replace' }
      ],
      siteName: '',
      province: '',
      regency: '',
      required
    }
  },
  computed: {
    ...mapState({
      SiteOptions: state => state.site.options,
      ProvinceOptions: state => state.region.province,
      RegencyOptions: state => state.region.regency,
      DistrictOptions: state => state.region.district,
      DeviceOptions: state => state.device.options
    }),
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    }
  },
  watch: {
     select_6(obj) {
      // this.$store.dispatch('site/setFilterProvince', obj)
      return this.$store.dispatch('region/regency', obj)
    },
    select_7(obj) {
      // this.$store.dispatch('site/setFilterRegency', obj)
      // return this.$store.dispatch('site/getByFilter')
    },
  },
  created() {
    this.$store.dispatch('site/getByNonFilter')
    this.$store.dispatch('region/province')
    this.$store.dispatch('device/getDeviceList')
  },
  methods: {
    initMap(latittute, longtitude) {
      const myLatlng = { lat: latittute, lng: longtitude }
      this.styledMapType = new google.maps.StyledMapType(
        [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              { visibility: 'off' }
            ]
          }
        ],
        { name: 'Styled Map' }
      )
      const map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 12,
        center: myLatlng,
      }
      )
      // Create the initial InfoWindow.
      let infoWindow = new google.maps.InfoWindow({
        content: `${this.siteName} 
          <hr> Regency : ${this.regency} 
          <br> Province : ${this.province} 
          `,
        position: myLatlng,
      })

      infoWindow.open(map)

      // Create the search box and link it to the UI element.
      const input = document.getElementById("pac-input")
      const searchBox = new google.maps.places.SearchBox(input)

      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
      // Bias the SearchBox results towards current map's viewport.
      map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds())
      })

      let markers = [];

      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }

        // Clear out the old markers.
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];

        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }

          const icon = {
            url: place.icon,
            size: new google.maps.Size(71, 71),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(17, 34),
            scaledSize: new google.maps.Size(25, 25),
          };

          // console.log(place.geometry.location.toJSON());
          // Close the current InfoWindow.
          this.form.text_3 = place.geometry.location.toJSON().lat
          this.form.text_4 = place.geometry.location.toJSON().lng
          infoWindow.close()

          // Create a new InfoWindow.
          infoWindow = new google.maps.InfoWindow({
            position: place.geometry.location.toJSON(),
          })
          this.geocoder = new google.maps.Geocoder()
          this.geocoder.geocode({ 'location': place.geometry.location.toJSON() }, function (results, status) {
            let resultsData = results[0]
            console.log(resultsData)
            const contentString =
              '<div id="content">' +
              '<div id="siteNotice">' +
              "</div>" +
              '<h1 id="firstHeading" class="firstHeading">' + resultsData.address_components[0].long_name + '</h1>' +
              "<p>" + resultsData.formatted_address + "</p>" +
              "</div>" +
              "</div>"
            // JSON.stringify(mapsMouseEvent.latLng.toJSON(), null, 2)
            infoWindow.setContent(contentString)
          })
          infoWindow.open(map)

          // Create a marker for each place.
          markers.push(
            new google.maps.Marker({
              map,
              icon,
              title: place.name,
              position: place.geometry.location,
            })
          );
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
      })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    validationForm() {
      this.show = true
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            const formData = this.form
            this.$store.dispatch('temperature/formPostPut', formData)
              .then(res => {
                this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
              },
                err => {
                  this.show = false
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                })
          } else {
            this.show = false
            this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d }
      })
    },
    getData(id) {
      this.$store.dispatch('temperature/getByIdInstall', id).then(data => {
        this.form.id = id
        this.form.select_1 = `${data.device_code} - SN${data.device_serial_number}`
        this.form.text_1 = data.device_installator_company
        this.form.text_2 = data.device_installator_name
        this.form.text_3 = data.device_latitude
        this.form.text_4 = data.device_longitude
        this.form.text_5 = data.device_update_interval
        this.form.text_6 = data.device_status
        if (this.form.text_6 === "IN") {
          this.form.text_6 = 'Online'
        }
        if (this.form.text_6 === "ER") {
          this.form.text_6 = 'Offline'
        }
        this.form.date_1 = data.device_installation_date
        this.form.select_9 = data.site_name
        this.form.UrlInstalasi = data.device_file_documentation
        this.form.UrlBast = data.device_file_bast
        this.form.UrlKalibrasi = data.device_file_calibration
        this.show = false
        this.siteName = data.site_name
        this.regency = data.regency_name
        this.province = data.province_name
        this.initMap(parseFloat(data.device_latitude), parseFloat(data.device_longitude))
        console.log(data);
      })
    },
    reset() {
      this.form.select_1 = ''
      this.form.text_1 = ''
      this.form.text_2 = ''
      this.form.text_3 = ''
      this.form.text_4 = ''
      this.form.text_5 = ''
      this.form.text_6 = ''
      this.form.date_1 = ''
      this.form.select_9 = ''
      this.form.UrlInstalasi = ''
      this.form.UrlBast = ''
      this.form.UrlKalibrasi = ''
    },
    UploadRenderInstalasi(e) {
      if (this.form.UrlInstalasi) {
        URL.revokeObjectURL(this.form.UrlInstalasi);
      }
      const instalasi = e.target.files[0];
      this.form.instalasi = instalasi
      this.form.setUpload = 'upload'
      this.form.UrlInstalasi = URL.createObjectURL(e.target.files[0])
    },
    UploadRenderBast(e) {
      if (this.form.UrlBast) {
        URL.revokeObjectURL(this.form.UrlBast);
      }
      const bast = e.target.files[0];
      this.form.bast = bast
      this.form.setUpload2 = 'upload'
      this.form.UrlBast = URL.createObjectURL(e.target.files[0])
    },
    UploadRenderKalibrasi(e) {
      if (this.form.UrlKalibrasi) {
        URL.revokeObjectURL(this.form.UrlKalibrasi);
      }
      const kalibrasi = e.target.files[0];
      this.form.kalibrasi = kalibrasi
      this.form.setUpload3 = 'upload'
      this.form.UrlKalibrasi = URL.createObjectURL(e.target.files[0])
    }
  },
  mounted() {
    // navigator.geolocation.getCurrentPosition((position) => {
    //   this.initMap(position.coords.latitude, position.coords.longitude)
    // })
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style scoped>
#map {
  height: 600px;
  width: 100%;
}
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>